import React from "react";
import {
  List,
  Datagrid,
  TextField,
  EmailField,
  EditButton,
  DeleteButton,
  ImageField,
  ArrayField,
  SingleFieldList,
  ChipField,
  RecordContext,
} from "react-admin";
import { makeStyles } from "@material-ui/core/styles";
import { CustomEmailField } from "../CustomEmailField";
import SimpleChipField from "../SimpleChipField";
import { countries } from "../../data";

const useImageFieldStyles = makeStyles((theme) => ({
  image: {
    // This will override the style of the <img> inside the <div>
    width: 80,
  },
}));

const BrandList = (props) => {
  const imageFieldClasses = useImageFieldStyles();

  return (
    <List {...props}>
      <Datagrid rowClick="edit">
        <TextField source="name" />
        <TextField source="listingValue" />
        <ArrayField source="countries">
          <SingleFieldList>
            <SimpleChipField source="record">
              <RecordContext>
                {(record) => (
                  <>
                    {countries
                      .filter((country) => country.code === record)
                      .map((country) => (
                        <span>
                          {country.flag} {country.code}
                        </span>
                      ))}
                  </>
                )}
              </RecordContext>
            </SimpleChipField>
          </SingleFieldList>
        </ArrayField>
        <ImageField
          source="brandLogo.src"
          label="Brand Logo"
          classes={imageFieldClasses}
        />
      </Datagrid>
    </List>
  );
};

export default BrandList;
